export default {
  title: "Service de réservation de l'entreprise désactivé",
  description:
    "Le service de réservation est actuellement inactif pour cette entreprise. Vous pouvez l'activer sous Services.",
  button: {
    settings: 'Accéder aux paramètres',
  },
};
